import { Check } from "@material-ui/icons";
import { Divider, Stack } from "@mui/material";
import React, { useEffect, useState } from "react";
import Button from "../Button";
import IyugaTooltip from "../IyugaTooltip";

const PasswordInput = ({ password, onChange, onCheckPress, ...props }) => {
  //   const [password, setPassword] = useState("");
  const [strength, setStrength] = useState("");
  const [strengthColor, setStrengthColor] = useState("red"); // Default color for strength
  const [isDisabled, setIsDisabled] = useState(true);

  const evaluatePassword = (password) => {
    let strength = 0;
    if (password.length < 8) return 0;
    if (password.length > 8) strength += 1;
    if (password.match(/[a-z]+/)) strength += 1;
    if (password.match(/[A-Z]+/)) strength += 1;
    if (password.match(/[0-9]+/)) strength += 1;
    if (password.match(/[\^$*.\[\]{}()?“!@#%&/\\,><':;|_~`]/)) strength += 1;
    return strength;
  };

  const passwordRequirementsTooltip = (
    <Stack pl={1} gap={1}>
      <div
        style={{
          fontFamily: "DM Sans",
          fontSize: "16px",
          fontWeight: 500,
        }}
      >
        For a strong password it must:
      </div>
      <ul
        style={{
          color: "#565556",
          fontFamily: "DM Sans",
          fontSize: 12,
          margin: 0,
        }}
      >
        <li>Include both lower and upper case characters</li>
        <li>Include at least 1 number or symbol</li>
        <li>Be at least 8 characters long</li>
      </ul>
      <div style={{ borderBottom: "0.6px solid #565556" }}></div>
      <div style={{ color: "#123051", fontFamily: "DM Sans", fontSize: 12 }}>
        *Or simply autogenerate a key!
      </div>
    </Stack>
  );

  useEffect(() => {
    const strengthLevels = ["Weak", "Weak", "Good", "Good", "Good", "Strong"];
    const passwordStrength = evaluatePassword(password);
    setStrength(strengthLevels[passwordStrength]);
    console.log({ passwordStrength });
    // Set color based on password strength
    switch (passwordStrength) {
      case 5:
        setStrengthColor("#29C18C"); // Strong
        break;
      case 2:
      case 3:
      case 4:
        setStrengthColor("#F5CC3B"); // Good
        break;
      case 1:
      case 0:
      default:
        setStrengthColor("#F32A00"); // Weak
        break;
    }

    if (password.length > 0 && password.length > 8) setIsDisabled(false);
  }, [password]);

  const handleChange = (event) => {
    if (event.target.value?.length < 8) {
      setIsDisabled(true);
    } else {
      setIsDisabled(false);
    }
    onChange(event.target.value);
  };

  return (
    <div>
      <Stack gap={1} direction={"row"} alignItems={"center"}>
        <input
          {...props}
          // type="password"
          value={password}
          onChange={handleChange}
          maxLength={20}
          style={{
            width: 250,
            height: 40,
            padding: "10px",
            color: "#123051", // Text-Blue
            fontFamily: "DM Sans",
            fontSize: "0.75rem",
            fontWeight: 400,
            lineHeight: "1.25rem",
            border: "1px solid #E1E1E1", // Stroke-Grey
            borderRadius:4,
          }}
        />

        <Button
          onClick={() => {
            if (!isDisabled) {
              onCheckPress();
              setIsDisabled(true);
            }
          }}
          style={{width:100}}
          variant={"outlined"}
          disabled={isDisabled}
        >
          Add Key
        </Button>
        <IyugaTooltip placement="right" tooltip={passwordRequirementsTooltip} />
      </Stack>
      {password?.length > 0 && (
        <div
          style={{
            marginTop: "5px",
            color: "#565556",
            fontFamily: "DM Sans",
            fontSize: "0.75rem",
            fontStyle: "normal",
            fontWeight: 400,
            lineHeight: "1.25rem",
          }}
        >
          Password Strength:{" "}
          <span style={{ color: strengthColor, fontWeight: 500 }}>
            {strength}
          </span>
        </div>
      )}
    </div>
  );
};

export default PasswordInput;
